import ko from "knockout";
import MyFlow from "flow/MyFlow";
import { Theme } from "flow/entities/Theme";
import themeCache from "flow/caches/themeCache";
import environment from "flow/configuration/environment";
import dataService from "flow/data/service";

export default class ThemeSelectorUserTab {
    themes = ko.observableArray<Theme>(themeCache.get());
    originalSelectedId = environment.get<string>(environment.keys.selectedTheme);
    selectedThemeId = ko.observable<string>(this.originalSelectedId);
    applyEnabled = ko.computed(() => this.selectedThemeId() !== this.originalSelectedId);

    constructor(private readonly myFlow: MyFlow) {}

    apply() {
        dataService.selectTheme(this.myFlow, this.selectedThemeId()).then(() => {
            this.myFlow.refreshFlow();
        });
    }
}
